import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";

const DataQualitySection = ({ lead, editData, setEditData, isEditing }) => {
  return (
    <Card className="border-slate-200">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium text-slate-600">Data Quality</CardTitle>
      </CardHeader>
      <CardContent>
        {isEditing ? (
          <Select
            value={editData.data_quality_feedback || "_none_"}
            onValueChange={(value) => setEditData(prev => ({ 
              ...prev, 
              data_quality_feedback: value === "_none_" ? null : value 
            }))}
          >
            <SelectTrigger className={`text-sm ${editData.data_quality_feedback ? 'border-red-300 bg-red-50' : ''}`}>
              <SelectValue placeholder="Select if issue" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="_none_">No issues</SelectItem>
              <SelectItem value="incorrect_details">Incorrect details</SelectItem>
              <SelectItem value="business_closed">Customer business closed</SelectItem>
              <SelectItem value="doesnt_deal_in_fabric">Doesn't deal in fabric</SelectItem>
              <SelectItem value="bad_experience">Bad experience with Locofast</SelectItem>
              <SelectItem value="duplicate_entry">Duplicate entry</SelectItem>
            </SelectContent>
          </Select>
        ) : (
          <div className={`text-sm px-3 py-2 rounded ${
            lead.data_quality_feedback 
              ? 'bg-red-50 text-red-700 border border-red-200' 
              : 'bg-slate-50 text-slate-600'
          }`}>
            {lead.data_quality_feedback 
              ? {
                  'incorrect_details': 'Incorrect details',
                  'business_closed': 'Customer business closed',
                  'doesnt_deal_in_fabric': "Doesn't deal in fabric",
                  'bad_experience': 'Bad experience with Locofast',
                  'duplicate_entry': 'Duplicate entry'
                }[lead.data_quality_feedback] || lead.data_quality_feedback
              : 'No issues'
            }
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default DataQualitySection;
